module.exports = "https://cdn2-fs.clearscore.com/flux/images/7f4ae26e93e22bbbc218cc76f589002f.jpg";